/**
 * Log and report error to Sentry
 */
import { captureException, withScope } from '@sentry/browser'
import zionDebug from '@fs/zion-debug'

const debug = zionDebug('identity:logError')

export default function noticeError(error, fingerprint) {
  if (error.noticeError === false) {
    // ignore errors with this flag
    return
  }
  const status = error.response?.status
  if (status === 401 || status === 453) {
    // Errors with this response status end up with a page reload and re-login (see zion-axios)
    // It's extra noise to log these type of errors.
    return
  }
  withScope(function withExtraData(scope) {
    setExtraErrorResponseData(scope, error)
    try {
      if (fingerprint) {
        scope.setFingerprint(fingerprint)
      }
      captureException(error)
    } catch (err) {
      // Sentry can throw an error if there is a network issue so ignore and continue
    }
  })
  debug(error)
}

// Add fingerprint to help group errors as well as extra data (shows up in the "Additional Data" on the event page)
// See https://docs.sentry.io/platforms/javascript/data-management/event-grouping/sdk-fingerprinting/
// and https://docs.sentry.io/platforms/javascript/enriching-events/context/
function setExtraErrorResponseData(scope, error) {
  const { response } = error
  if (!response) {
    return
  }
  const dataMessage = response?.data?.message ?? ''
  const errorMessage = response?.data?.error?.message ?? ''
  const warningHeader = response?.headers?.warning ?? ''
  const fingerprint = []
  if (dataMessage) {
    scope.setExtra('response.data.message', dataMessage)
    fingerprint.push(dataMessage)
  }
  if (errorMessage) {
    scope.setExtra('response.data.error.message', errorMessage)
    fingerprint.push(errorMessage)
  }
  if (warningHeader) {
    scope.setExtra('response.headers.warning', warningHeader)
    fingerprint.push(warningHeader)
  }
  if (fingerprint.length) {
    scope.setFingerprint(fingerprint)
  }
}
